var _path, _rect, _rect2, _path2, _rect3, _rect4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPedal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    "data-name": "Vrstva 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52.13 52.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.05,10,50.61,3.71,50.21,2A2.3,2.3,0,0,0,48.1,0H31.54a2.12,2.12,0,0,0-1.92,1.4L25.07,11.85a3.3,3.3,0,0,0-.28,1.33V17a3.35,3.35,0,0,0,.28,1.34l4.55,10.48a2.2,2.2,0,0,0,1.92,1.46H48.1a2.36,2.36,0,0,0,2.11-2l.4-1.77,1.44-6.29a4,4,0,0,0,.08-.78V10.76A3.94,3.94,0,0,0,52.05,10ZM28.39,11.94l3.35-7.67a.84.84,0,0,1,.75-.54h7.84a.68.68,0,0,1,.63.95l-3.12,7.16a4.27,4.27,0,0,0-.18.54.69.69,0,0,1-.66.52H29A.69.69,0,0,1,28.39,11.94ZM40.33,26.45H32.49a.85.85,0,0,1-.74-.56L28.4,18.23a.68.68,0,0,1,.62-.95h8a.67.67,0,0,1,.66.51,4.56,4.56,0,0,0,.18.52L41,25.48A.69.69,0,0,1,40.33,26.45Zm8.84-11.38v4a1,1,0,0,1,0,.3l-1.42,6.29a.92.92,0,0,1-.82.78H45.27a.83.83,0,0,1-.74-.56L40.63,17a1.32,1.32,0,0,1-.12-.52,4.74,4.74,0,0,1,0-2.74,1.32,1.32,0,0,1,.12-.52l3.9-8.92a.81.81,0,0,1,.74-.53h1.62a.88.88,0,0,1,.81.76l1.43,6.27a1,1,0,0,1,0,.29Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.99,
    y: 13.43,
    width: 2.49,
    height: 3.37,
    rx: 0.39
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22.19,
    y: 12.72,
    width: 1.89,
    height: 4.91,
    rx: 0.39
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,24.17a2.18,2.18,0,0,0-1.92-1.45H4a2.35,2.35,0,0,0-2.1,2l-.4,1.77L.08,32.79a3.39,3.39,0,0,0-.08.78v8.61A3.44,3.44,0,0,0,.08,43l1.43,6.27L1.91,51A2.31,2.31,0,0,0,4,53H20.58a2.13,2.13,0,0,0,1.92-1.41L27.06,41.1a3.3,3.3,0,0,0,.28-1.33V36a3.4,3.4,0,0,0-.28-1.35ZM11.78,26.45h7.85a.87.87,0,0,1,.74.58l3.35,7.68a.69.69,0,0,1-.62,1h-8a.68.68,0,0,1-.66-.51,4.88,4.88,0,0,0-.18-.54l-3.12-7.19A.71.71,0,0,1,11.78,26.45ZM7.59,48.69a.83.83,0,0,1-.74.54H5.23a.89.89,0,0,1-.81-.77L3,42.19a1.53,1.53,0,0,1,0-.3v-8a1.36,1.36,0,0,1,0-.29l1.42-6.31a1,1,0,0,1,.82-.81H6.85a.87.87,0,0,1,.74.58L11.49,36a1.37,1.37,0,0,1,.12.53,4.74,4.74,0,0,1,0,2.74,1.32,1.32,0,0,1-.12.52ZM23.73,41l-3.36,7.68a.81.81,0,0,1-.74.54H11.78a.68.68,0,0,1-.62-1l3.12-7.16a4.12,4.12,0,0,0,.18-.53.68.68,0,0,1,.66-.52h8A.68.68,0,0,1,23.73,41Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30.65,
    y: 36.15,
    width: 2.49,
    height: 3.37,
    rx: 0.39
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 28.11,
    y: 35.39,
    width: 1.89,
    height: 4.91,
    rx: 0.39
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPedal);
export default __webpack_public_path__ + "static/media/pedal.f657442b7fe320636d038f210fd5adbc.svg";
export { ForwardRef as ReactComponent };